import { render, staticRenderFns } from "./AnswerSheet.vue?vue&type=template&id=70988574&"
import script from "./AnswerSheet.vue?vue&type=script&lang=js&"
export * from "./AnswerSheet.vue?vue&type=script&lang=js&"
import style0 from "./AnswerSheet.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports